import { useAtom, useAtomValue } from 'jotai';
import React, { useEffect } from 'react';
import AlertsConfig from '../AlertsConfig';
import Summary from '../summary';
import { displayConfigAtom, isConfigLoadingAtom, totalCombinationsAtom } from '../atoms';
import { useFetchConfigList } from '@components/metrics-panel-hz/hooks/alerts/useFetchConfigList';
import { aiAlertsConfigSelector } from '@store/common/selectors';
import { useSelector } from 'react-redux';
import { useLocationQuery } from '@src/hooks';

const AiAlertsMain = () => {
  const [displayConfig, setDisplayConfig] = useAtom(displayConfigAtom);
  const [, setLoading] = useAtom(isConfigLoadingAtom);
  const [, setTotalComb] = useAtom(totalCombinationsAtom);
  const isConfigFeatureEnabled = useSelector(aiAlertsConfigSelector);
  const { data, isFetching, isLoading } = useFetchConfigList(isConfigFeatureEnabled);
  const { aiAlertsConfig = [] } = data ?? {
    aiAlertsConfig: [],
  };
  const query = useLocationQuery();
  const config = query.get('config');

  useEffect(() => {
    if (config == 'true') {
      // show the config popup incase the query param is present and is true
      setDisplayConfig(true);
    } else {
      setDisplayConfig(false);
    }
  }, [config]);

  useEffect(() => {
    setLoading(isFetching);
    if (!isFetching && aiAlertsConfig.length) {
      const { totalCombinations = 0 } = aiAlertsConfig[0];
      setTotalComb(totalCombinations);
    }
  }, [isFetching, aiAlertsConfig, setTotalComb, setLoading]);

  return displayConfig ? <AlertsConfig isConfigLoading={isLoading} /> : <Summary />;
};

export default AiAlertsMain;
